/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { task } from 'ember-concurrency';
import RouterService from '@ember/routing/router-service';
import moment from 'moment-timezone';
import { computed } from '@ember/object';
import ApiCredentialModel from 'cio/models/api-credential';
import SegmentAuthService, { SegmentAuthAction } from 'cio/services/segment-auth';
import { IntegrationMethod, IntegrationStatus } from 'cio/models/setup-guide';
import AnalyticsService from 'cio/services/analytics';
import AlertsService from 'cio/services/alerts';
import AuthService from 'cio/services/auth';
import { joinWordsAsSnippets } from 'cio/utils/join-words';

interface Args {
  onSelect: (method: IntegrationMethod, connectedAt: number) => void;
  status: IntegrationStatus;
}

export default class SetupGuideSourcesSegment extends Component<Args> {
  @service router!: RouterService;
  @service environment!: EnvironmentService;
  @service segmentAuth!: SegmentAuthService;
  @service analytics!: AnalyticsService;
  @service alerts!: AlertsService;
  @service auth!: AuthService;

  @computed('environment.current.enabledIdentifiers.[]')
  get segmentDescription() {
    let { enabledIdentifiers } = this.environment.current;
    let snippets = joinWordsAsSnippets(enabledIdentifiers);

    return `This workspace uses ${snippets} as ${
      enabledIdentifiers.length === 1 ? 'the identifier. Pass it' : 'identifiers. Pass them'
    } as the Segment <code>user_id</code>.`;
  }

  segmentOAuthIntegrateTask = task(async (selectedCredential: ApiCredentialModel) => {
    this.analytics.track('onboarding', 'integration_details_clicked', { type: 'segment' });

    try {
      await this.segmentAuth.authenticate.perform(selectedCredential, SegmentAuthAction.Create);
      await this.segmentAuth.segmentIn.perform();
      this.args.onSelect('segment', moment().unix());
      this.alerts.success(
        'integrations.segment_in.connected',
        "You've connected your Customer.io workspace to your Segment account.",
      );
    } catch {
      // Errors are handled by the authentication task.
    }
  });
}
